<template>
  <div class="login p-5">
    <div class="d-flex flex-center mb-5">
      <img src="/media/svg/logos/logo.svg" height="32" alt="Kema" />
    </div>

    <h3 class="d-flex flex-center text-black-50 mb-5">
      Login into your Account
    </h3>

    <div class="login-form">
      <validation-observer ref="observer">
        <div
          class="alert alert-light-danger fade text-center font-weight-bolder"
          :class="{ show: error }"
          v-html="error || '&nbsp;'"
          v-if="error && error.length"
        ></div>

        <b-form-group
          label="Email"
          label-for="email"
          label-class="font-weight-bolder"
        >
          <validation-provider
            name="email"
            rules="required|email"
            v-slot="{ errors }"
          >
            <b-form-input
              placeholder="Your email address"
              :disabled="loading"
              v-model="form.email"
            />
            <b-form-text
              text-variant="danger"
              class="font-weight-bold"
              v-if="errors[0]"
              >{{ errors[0] }}</b-form-text
            >
          </validation-provider>
        </b-form-group>

        <b-form-group>
          <div class="d-flex align-items-center justify-content-between">
            <label class="font-weight-bolder">Password</label>

            <router-link
              class="font-weight-bolder"
              :to="{ name: 'forgot-password' }"
              >Forgot password?</router-link
            >
          </div>

          <validation-provider
            name="password"
            rules="required|min:3|max:22"
            v-slot="{ errors }"
          >
            <b-form-input
              type="password"
              placeholder="Your password"
              :disabled="loading"
              v-model="form.password"
            />
            <b-form-text
              text-variant="danger"
              class="font-weight-bold"
              v-if="errors[0]"
              >{{ errors[0] }}</b-form-text
            >
          </validation-provider>
        </b-form-group>

        <div class="text-center">
          <button
            ref="submit"
            class="btn btn-dark btn-pill w-100 mt-6"
            :disabled="loading"
            :class="{
              'spinner spinner-success spinner-lg spinner-left': loading,
            }"
            @click.stop="submit"
          >
            <span v-if="loading">Logging In...</span>
            <span v-else>Log in</span>
          </button>
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider,
} from "vee-validate/dist/vee-validate.full";

import { LOGIN } from "@/store/auth.module";
import { formatErrorMessage } from "@/utils/random_utils";

export default {
  name: "Login-Page",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      error: null,
      loading: false,
      form: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    async submit() {
      const valid = await this.$refs.observer.validate();

      if (!valid) return;

      const payload = {
        email: this.form.email,
        password: this.form.password,
      };

      this.error = null;
      this.loading = true;

      return this.$store
        .dispatch(LOGIN, payload)
        .then(() => {
          const nextPath = this.$route.query.next || { name: "home" };
          return this.$router.push(nextPath);
        })
        .catch(({ message }) => {
          this.error = formatErrorMessage(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
